// extracted by mini-css-extract-plugin
export default {"link":"OpenModal_link__k7uhM","placeHolderShimmer":"OpenModal_placeHolderShimmer__hspy1"};